import React from 'react';
import "../Figure.css"

function Figure6() {
  return (
    <div>
        <table className="equal-width-table">
          <thead>
            <tr>
              <th className="concentration-header"> Concentration (mg/mL)</th>
              <th> 2 </th>
              <th> 1 </th>
              <th> 0.5 </th>
              <th> 0.25 </th>
              <th> 0.125 </th>
              <th> 0 </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> Signal </th>
              <td> 1.164 </td>
              <td> 0.673 </td>
              <td> 0.407 </td>
              <td> 0.258 </td>
              <td> 0.162 </td>
              <td> 0.095 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure6;
